var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersBtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.234 -4.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.121,30.244a4.676,4.676,0,0,0-3.4-4.494V7.274a1.274,1.274,0,1,0-2.547,0V25.75a4.667,4.667,0,0,0,0,8.988v2.729a1.274,1.274,0,1,0,2.547,0V34.738A4.676,4.676,0,0,0,15.121,30.244Zm-4.676,2.138a2.129,2.129,0,1,1,2.129-2.129A2.129,2.129,0,0,1,10.445,32.382Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3,30.244a4.676,4.676,0,0,0-3.4-4.494V7.274a1.274,1.274,0,0,0-2.547,0V25.75a4.667,4.667,0,0,0,0,8.988v2.729a1.274,1.274,0,1,0,2.547,0V34.738A4.676,4.676,0,0,0,41.3,30.244Zm-4.676,2.138a2.129,2.129,0,1,1,2.129-2.129A2.129,2.129,0,0,1,36.625,32.382Z",
    transform: "translate(-2.363 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86,14.507A4.676,4.676,0,0,0,22.262,19V37.477a1.274,1.274,0,1,0,2.547,0V19a4.667,4.667,0,0,0,0-8.988V7.284a1.274,1.274,0,0,0-2.547,0v2.729A4.676,4.676,0,0,0,18.86,14.507Zm4.676-2.138A2.129,2.129,0,1,1,21.407,14.5,2.129,2.129,0,0,1,23.536,12.369Z",
    transform: "translate(-1.182 -0.001)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersBtIcon);
export default __webpack_public_path__ + "static/media/filters-bt-icon.aeaf62c0a888db32f9a6452fdd9be198.svg";
export { ForwardRef as ReactComponent };